// src/constants/categories.js
import React from "react";
import IcecreamIcon from "@mui/icons-material/Icecream";
import LunchDiningIcon from "@mui/icons-material/LunchDining";
import LocalDrinkIcon from "@mui/icons-material/LocalDrink";

import { logDev } from "../utils/logger.js";

export const BASE_CATEGORIES = {
  Matin: ["Sucré", "Salé", "Boisson"],
  Midi: ["Apéro", "Entrée", "Plat", "Dessert", "Boisson"],
  Soir: ["Apéro", "Entrée", "Plat", "Dessert", "Boisson"]
};

export const makeCategoryLabels = (t) => {
   logDev("🔥 makeCategoryLabels CALLED", { tType: typeof t });

    return {
      Sucré: t("SweetItem"),
      Salé: t("SaltyItem"),
      Boisson: t("Beverage"),
      Apéro: t("Aperitif"),
      Entrée: t("Starter"),
      Plat: t("MainCourses"),
      Dessert: t("Dessert")
    };
  };

export const CATEGORY_ICONS = {
  Sucré: <IcecreamIcon fontSize="small" />,
  Salé: <LunchDiningIcon fontSize="small" />,
  Boisson: <LocalDrinkIcon fontSize="small" />
};

// 🎨 Couleurs par catégorie (définies par Mercier)
export const CATEGORY_COLORS = {
  "Sucré": "#FFFDF2",        // jaune ultra pastel (quasi crème)
  "Salé": "#F7F7F2",         // blanc cassé (très léger)
  "Boisson": "#F3F9FF",      // bleu pastel ultra léger
  "Entrée": "#F5F1EA",       // beige/marron clair très doux
  "Plat": "#FFF6EE",         // orange pastel très très clair
  "Dessert": "#FFF6FA",      // rose pastel ultra léger
  "Apéro": "#F2ECE8"         // mokka pastel très doux
};


export const getCategoryColor = (categorie) =>
  CATEGORY_COLORS[categorie] || "#ddd";


// Fallback visuel uniquement (ne jamais envoyer ces _id au backend)
export const getCategoriesForMoment = (momentKey, { t, isMobile }) => {
  logDev("🔥 getCategoriesForMoment CALLED", { tType: typeof t, momentKey });

  const safeT = typeof t === "function" ? t : (x) => x;   // 🔥 fallback
  const labels = makeCategoryLabels(safeT);
  const cats = (BASE_CATEGORIES[momentKey] || []).map((cat) => ({
    _id: `fake-${momentKey}-${cat}`,
    name: cat,
    label: labels[cat],
    icon: isMobile ? CATEGORY_ICONS[cat] : null
  }));

  logDev("[categories] getCategoriesForMoment", { momentKey, isMobile, cats });
  return cats;
};

export const ALL_CATEGORIES = Array.from(
  new Set([
    ...BASE_CATEGORIES.Matin,
    ...BASE_CATEGORIES.Midi,
    ...BASE_CATEGORIES.Soir
  ])
);

